import BaseApi from 'api/core/baseApi';
import { ENDPOINTS } from 'api/config/endpoints';

class ExportApi extends BaseApi {
  constructor() {
    super(ENDPOINTS.EXPORT);
  }

  revokeTask(exportId) {
    return this.httpClient.delete(
      `${this.getResourceUrl()}${exportId}/revoke/`,
    );
  }
}

export default new ExportApi();
